import AddEquipmentTaskModal from './main.add-task'

export default AddEquipmentTaskModal